import { createReducer, on } from '@ngrx/store';
import { PayoutsState, initialPayoutsState } from './payouts.state';
import {
  getPayouts,
  getPayoutsSuccess,
  getPayoutsFailure,
  createPayout,
  createPayoutSuccess,
  createPayoutFailure,
  changePayoutStatus,
  changePayoutStatusSuccess,
  changePayoutStatusFailure,
  getWalletBalance,
  getWalletBalanceSuccess,
  getWalletBalanceFailure,
  resetPayouts,
} from './payouts.actions';

const reducer = createReducer(
  initialPayoutsState,

  on(getPayouts, createPayoutSuccess, createPayout, getWalletBalance, changePayoutStatus, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(getPayoutsSuccess, (state, { data }) => ({
    ...state,
    payouts: data.result || [],
    isLoading: false,
    error: null,
  })),

  on(
    getPayoutsFailure,
    createPayoutFailure,
    changePayoutStatusFailure,
    getWalletBalanceFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error: error?.message || 'Failed ',
    }),
  ),

  on(changePayoutStatusSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),

  on(getWalletBalanceSuccess, (state, { balance }) => ({
    ...state,
    walletBalance: balance,
    isLoading: false,
    error: null,
  })),

  on(resetPayouts, () => initialPayoutsState),
);

export function payoutsReducer(state = initialPayoutsState, action: any) {
  return reducer(state, action);
}
